export const LIMIT_CREATION_ERROR_CODE = 'EFLD022';
